import m from 'mithril';

export type Language = 'en' | 'ar';

export const dictionary = {
    en: {
        'nav.home': 'Home',
        'nav.shop': 'Shop',
        'nav.about': 'About',
        'nav.signin': 'Sign In',
        'hero.subtitle': 'Caring for Little Ones',
        'hero.title': 'Health & Joy, Delivered.',
        'hero.description': 'Discover our specialized selection of premium children\'s medicines, vitamins, and educational special toys designed to nurture growth.',
        'hero.cta': 'Shop the Collection',
        'products.title': 'Featured Care & Play',
        'products.subtitle': 'Safe, trusted, and pediatrician approved.',
        'products.viewAll': 'View All',
        'products.loading': 'Loading products...',
        'products.empty': 'No products found.',
        'product.addToCart': 'Add to Cart',
        'product.new': 'New',
        'footer.rights': '© 2026 Khalid Kids & Care. All rights reserved.',
        'lang.switch': 'العربية',
        'theme.night': 'Night',
        'theme.day': 'Day',
        'theme.ocean': 'Ocean',
        'theme.forest': 'Forest',
        'categories.title': 'Special Categories',
        'categories.tech': 'Kids Medicine',
        'categories.audio': 'Educational Toys',
        'categories.accessories': 'Vitamins & Health',
        'categories.explore': 'Explore'
    },
    ar: {
        'nav.home': 'الرئيسية',
        'nav.shop': 'المتجر',
        'nav.about': 'معلومات عنا',
        'nav.signin': 'تسجيل الدخول',
        'hero.subtitle': 'رعاية الصغار بمحبة',
        'hero.title': 'صحة وسعادة، نوصلها إليكم.',
        'hero.description': 'اكتشف مجموعتنا المتخصصة من أدوية الأطفال والفيتامينات والألعاب التعليمية المصممة لرعاية نموهم بشكل آمن.',
        'hero.cta': 'تسوق الآن',
        'products.title': 'منتجات الرعاية والألعاب',
        'products.subtitle': 'آمنة، موثوقة، ومعتمدة من الأطباء.',
        'products.viewAll': 'عرض الكل',
        'products.loading': 'جاري تحميل المنتجات...',
        'products.empty': 'لم يتم العثور على منتجات.',
        'product.addToCart': 'أضف إلى السلة',
        'product.new': 'جديد',
        'footer.rights': '© ٢٠٢٦ خالد أطفال ورعاية. جميع الحقوق محفوظة.',
        'lang.switch': 'English',
        'theme.night': 'ليلي',
        'theme.day': 'نهاري',
        'theme.ocean': 'محيطي',
        'theme.forest': 'غابة',
        'categories.title': 'تشكيلات مخصصة',
        'categories.tech': 'أدوية الأطفال',
        'categories.audio': 'ألعاب تعليمية',
        'categories.accessories': 'فيتامينات وصحة',
        'categories.explore': 'استكشف'
    }
};

export let currentLang: Language = 'en';

export const setLanguage = (lang: Language) => {
    currentLang = lang;
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    m.redraw();
};

export const t = (key: keyof typeof dictionary['en']): string => {
    return dictionary[currentLang][key] || key;
};
